import { CommonErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { IDataAlertInfo } from '../../ts/models/IDataAlertInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { Set } from '../../ts/models/Set';
import { DataAlerts } from '../../dda/resources/DataAlerts';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import {
  standardActionErrorMsg,
  ActionHelpers, standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { Messages, Formatters } from '../../codegen/Localize';
import { ReactAlertStringBodyProps, ReactAlertStringBody} from '../components/ReactAlertDialog';
import { IUserActionResult } from '../../ts/ServerApi/types/IUserActionResult';
import { TabStyles } from '@tableau/widgets';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';

function removeSelfFromAlert(alerts: Set<IDataAlertInfo>): Promise<any>{

    const ServerService = getSessionManagementServiceInstance();
    const self = ServerService.sessionUserId();

    function notifyResult(alerts: Set<IDataAlertInfo>, result: IResult) {
      ActionHelpers.displayStandardToastsForResult(
       alerts,
       result,
       {
        success: standardActionSuccessMsg(Messages.removeSelfFromDataAlertsSuccess),
        error: standardActionErrorMsg(Messages.removeSelfFromDataAlertsError),
       },
       (errorItem: IErrorItem<IDataAlertInfo>) => errorDetailFor(errorItem)
     );
    }

  function errorDetailFor(errorItem: IErrorItem<IDataAlertInfo>): IErrorDetail {
    const itemName = errorItem.item? errorItem.item.name : '';
    let errorMessage: string;

    switch (errorItem.error.code) {
      case CommonErrorCode.DataAlertNotFound:
        errorMessage = Messages.errorDataAlertNotFound({ ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.CallingUserInsufficientPermissions:
        errorMessage = Messages.errorDataAlertNoPermission({ ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.DataAlertRecipientNotFound:
        errorMessage = Messages.errorDataAlertNotRecipient({ ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      default:
        errorMessage = Messages.errorUnknown();
    }

    return { itemName, errorMessage };
  }

  let dialogBodyText: string;
  if (alerts.size() === 1) {
    dialogBodyText = Messages.confirmRemoveSelfFromAlert({
      ALERT_NAME: L10n.elideIfLong(alerts.first().name)
    });
  } else {
    dialogBodyText = Messages.confirmRemoveSelfFromAlerts({
      ALERT_COUNT: alerts.size(),
      ALERT_COUNT_LOC:Formatters.formatCount(alerts.size())
    });
  }

  const dialogInstance = openReactActionDialog<ReactAlertStringBodyProps, any, IUserActionResult>({
      title: null,
      dialogBodyStyle : {
        paddingTop: TabStyles.Spacing.ExtraLargeSpace,
        paddingBottom: TabStyles.Spacing.LargeSpace},
      bodyComponent: ReactAlertStringBody,
      initialBodyProps: {
        title: Messages.confirmRemoveSelfFromAlertTitle(),
        message: dialogBodyText
      },
      initialDialogState: {},
      actionName: Messages.confirmRemoveSelfButton(),
      action: () => DataAlerts.removeUsers({ dataAlertIds: alerts.keys(), userIds: [self] }),
      isActionDelete: true,
      dialogWidth: TabDialogWidth.width500px,
      dismissDialogOnActionFailed: true,
    });

    dialogInstance.result.then((result: IUserActionResult) => {
      notifyResult(alerts, result);
    });

    return Promise.resolve(dialogInstance.result);
}

export const RemoveSelfFromAlertsAction = {
    removeSelfFromAlert,
  };
